import { PipeTransform, Pipe, Injectable } from '@angular/core';
import {  AllActorCertificatesInfoController } from '../../models/actor/actor';


@Pipe({
  name: 'AllCertificatesViewPipe'
})

@Injectable()
export class AllCertificatesViewPipe implements PipeTransform {

  transform(value: AllActorCertificatesInfoController[], filter: string): AllActorCertificatesInfoController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: AllActorCertificatesInfoController) =>
      app.CredentialType != null && app.CredentialType.toLocaleLowerCase().indexOf(filter) != -1
      || app.CertificateType != null && app.CertificateType.toLocaleLowerCase().indexOf(filter) != -1
      || app.CredentialNumber != null && app.CredentialNumber.toLocaleLowerCase().indexOf(filter) != -1
      || app.IssuingAuthorityLongValue != null && app.IssuingAuthorityLongValue.toLocaleLowerCase().indexOf(filter) != -1
      || app.AdditionalDetail != null && app.AdditionalDetail.toLocaleLowerCase().indexOf(filter) != -1
      || app.Remarks != null && app.Remarks.toLocaleLowerCase().indexOf(filter) != -1
    ) : value;
  }

}
